
<template lang="pug">
div
  .grid__tr(v-for="row of rows")
    .grid__cell(
      v-for="cell of row.cells"
      :style="[style, cell.style]"
    ) {{getText_(cell)}}
</template>

<script>
export default {
  props: {
    grid: {type: Object, required: true},
    rows: {type: Array, required: true},
    getText: Function,
  },

  computed: {
    style() {
      return {
        width: this.grid.cellW + 'px',
        height: this.grid.cellH + 'px',
      }
    },

    getText_() {
      return this.getText || (cell => cell.text)
    },
  },
}
</script>
